import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import SupportFeature from "./SupportFeature";
import {useNavigatorFeature} from "../../useFeature";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import {useApplication} from "../../ApplicationProvider";
import {default as handlerErrorToast} from '../../components/toast/ErrorToast'
import FormSection from "../../forms/FormSection";
import ActionOnDate from "../../components/ActionOnDate";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import { LoadingButton } from '@mui/lab';
import {Box, Typography, useTheme} from "@mui/material";
import FormColumn from "../../forms/FormColumn";
import dayjs from "dayjs";

function SupportScreen() {
    const theme = useTheme();
    const style = styles(theme)
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new SupportFeature(application, navigator), navigator);

    const accountingDocumentsStartingDate = dayjs('2025-02-01');

    function executeClosureFor(date, errorMessage, closure) {
        if (date === '') {
            handlerErrorToast(errorMessage)
        } else {
            return closure()
        }
    }

    const handleDisableDate = () => {
        const date = feature.disabledDateField().value
        const closure = () => feature.disableDate();
        const errorMessage = "Se necesita una fecha para poder deshabilitarla";
        return executeClosureFor(date, errorMessage, closure);
    }

    const confirmOrdersOnSelectedDate = () => {
        const date = feature.orderConfirmationDateField().value
        const closure = () => feature.confirmOrdersOnSelectedDate();
        const errorMessage = "Se necesita una fecha para poder confirmarla";
        executeClosureFor(date, errorMessage, closure);
    }

    const importInvoicesManuallyForDate = () => {
        const date = feature.importInvoicesManuallyDateField().value
        const closure = () => feature.importInvoicesManuallyDate();
        const errorMessage = "Se necesita una fecha para poder deshabilitarla";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeInvoicesManuallyForDate = () => {
        const date = feature.synchronizeInvoicesManuallyDateField().value
        const closure = () => feature.synchronizeInvoicesManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder deshabilitarla";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeCreditNotesManuallyForDate = () => {
        const date = feature.synchronizeCreditNotesManuallyDateField().value
        const closure = () => feature.synchronizeCreditNotesManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder sincronizar notas de crédito";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeOrderStatesManuallyForDate = () => {
        const date = feature.synchronizeOrderStatesManuallyDateField().value
        const closure = () => feature.synchronizeOrderStatesManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder deshabilitarla";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeAccountingDocumentsManuallyForDate = () => {
        const date = feature.synchronizeAccountingDocumentsManuallyDateField().value
        const closure = () => feature.synchronizeAccountingDocumentsManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder deshabilitarla";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeDocumentApplicationsManuallyForDate = () => {
        const date = feature.synchronizeDocumentApplicationsManuallyDateField().value
        const closure = () => feature.synchronizeDocumentApplicationsManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder sincronizar aplicaciones de documentos";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeReceiptsManuallyForDate = () => {
        const date = feature.synchronizeReceiptsManuallyDateField().value
        const closure = () => feature.synchronizeReceiptsManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder sincronizar recibos";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeDebitNotesManuallyForDate = () => {
        const date = feature.synchronizeDebitNotesManuallyDateField().value
        const closure = () => feature.synchronizeDebitNotesManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder sincronizar notas de débito";
        executeClosureFor(date, errorMessage, closure);
    }

    const synchronizeWitholdingCertificatesManuallyForDate = () => {
        const date = feature.synchronizeWitholdingCertificatesManuallyDateField().value
        const closure = () => feature.synchronizeWitholdingCertificatesManuallyForDate();
        const errorMessage = "Se necesita una fecha para poder sincronizar certificados de retención";
        executeClosureFor(date, errorMessage, closure);
    }

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const screenContent = () => {
        return (
            <div>
                <LayoutContentToolbar title="Soporte"/>

                {application.hasGeneralSupportPermission() && (<FormSection title="Tienda">
                    <FormColumn>
                        <ActionOnDate
                            dateLabel="Cierre de fecha"
                            field={feature.disabledDateField()}
                            onClick={() => handleDisableDate()}
                            buttonLabel="Deshabilitar"
                            buttonLoading={feature.buttonsLoading}
                            disabled={feature.buttonsLoading}
                        />
                        <Box sx={{display: 'flex', justifyContent: 'left', alignItems: 'left'}}>
                            <LoadingButton
                                sx={style.synchronizeButton}
                                onClick={() => feature.synchronizeERP()}
                                loading={feature.buttonsLoading}
                                variant="contained"
                            >
                                {feature.buttonsLoading ? "Sincronizando..." : "Sincronización con ERP"}
                            </LoadingButton>
                        </Box>

                    </FormColumn>
                </FormSection>)}

                    {application.hasERPSupportPermission() && (<FormSection title="ERP-Bejerman">
                        <FormColumn>
                            <ActionOnDate
                                dateLabel="Envío de NPs"
                                field={feature.orderConfirmationDateField()}
                                onClick={() => confirmOrdersOnSelectedDate()}
                                buttonLabel="Confirmar" buttonLoading={feature.buttonsLoading}
                                disabled={feature.buttonsLoading}/>
                            <ActionOnDate
                                dateLabel="Sincronización de estados de órdenes con NPs"
                                field={feature.synchronizeOrderStatesManuallyDateField()}
                                onClick={() => synchronizeOrderStatesManuallyForDate()}
                                buttonLabel="Confirmar"
                                buttonLoading={feature.buttonsLoading}
                                disabled={feature.buttonsLoading}
                            />
                        </FormColumn>
                    </FormSection>)}

                    {application.hasEDISupportPermission() && <FormSection title="Krikos">
                        <ActionOnDate
                            dateLabel="Importación de facturas"
                            field={feature.importInvoicesManuallyDateField()}
                            onClick={() => importInvoicesManuallyForDate()}
                            buttonLabel="Confirmar"
                            buttonLoading={feature.buttonsLoading}
                            disabled={feature.buttonsLoading}
                        />
                    </FormSection>}

                    {application.hasCurrentAccountPermission() && <FormSection title="Cuentas Corrientes">
                        <FormColumn>
                            <Box sx={style.piece}>
                                <Typography sx={style.pieceTitle}>Facturas y notas de crédito/débito</Typography>
                                <Box sx={style.synchronizationsGrid}>
                                    <ActionOnDate
                                        dateLabel="Sincronización de Facturas"
                                        field={feature.synchronizeInvoicesManuallyDateField()}
                                        onClick={() => synchronizeInvoicesManuallyForDate()}
                                        buttonLabel="Confirmar"
                                        buttonLoading={feature.buttonsLoading}
                                        disabled={feature.buttonsLoading}
                                        minDate={accountingDocumentsStartingDate}
                                    />
                                    <ActionOnDate
                                        dateLabel="Sincronización de notas de crédito"
                                        field={feature.synchronizeCreditNotesManuallyDateField()}
                                        onClick={() => synchronizeCreditNotesManuallyForDate()}
                                        buttonLabel="Confirmar"
                                        buttonLoading={feature.buttonsLoading}
                                        disabled={feature.buttonsLoading}
                                        minDate={accountingDocumentsStartingDate}
                                    />
                                    <ActionOnDate
                                        dateLabel="Sincronización de notas de débito"
                                        field={feature.synchronizeDebitNotesManuallyDateField()}
                                        onClick={() => synchronizeDebitNotesManuallyForDate()}
                                        buttonLabel="Confirmar"
                                        buttonLoading={feature.buttonsLoading}
                                        disabled={feature.buttonsLoading}
                                        minDate={accountingDocumentsStartingDate}
                                    />
                                </Box>
                            </Box>
                            <Box sx={style.pieceWithSeparator}>
                                <Typography sx={style.pieceTitle}>Otros comprobantes</Typography>
                                <Box sx={style.synchronizationsGrid}>
                                <ActionOnDate
                                    dateLabel="Sincronización de documentos contables (sin facturas ni NC)"
                                    field={feature.synchronizeAccountingDocumentsManuallyDateField()}
                                    onClick={() => synchronizeAccountingDocumentsManuallyForDate()}
                                    buttonLabel="Confirmar"
                                    buttonLoading={feature.buttonsLoading}
                                    disabled={feature.buttonsLoading}
                                    minDate={accountingDocumentsStartingDate}
                                />
                                <ActionOnDate
                                    dateLabel="Sincronización de recibos"
                                    field={feature.synchronizeReceiptsManuallyDateField()}
                                    onClick={() => synchronizeReceiptsManuallyForDate()}
                                    buttonLabel="Confirmar"
                                    buttonLoading={feature.buttonsLoading}
                                    disabled={feature.buttonsLoading}
                                    minDate={accountingDocumentsStartingDate}
                                />
                                <ActionOnDate
                                    dateLabel="Sincronización de certificados de retención"
                                    field={feature.synchronizeWitholdingCertificatesManuallyDateField()}
                                    onClick={() => synchronizeWitholdingCertificatesManuallyForDate()}
                                    buttonLabel="Confirmar"
                                    buttonLoading={feature.buttonsLoading}
                                    disabled={feature.buttonsLoading}
                                    minDate={accountingDocumentsStartingDate}
                                />
                                <ActionOnDate
                                    dateLabel="Sincronización de aplicaciones de documentos"
                                    field={feature.synchronizeDocumentApplicationsManuallyDateField()}
                                    onClick={() => synchronizeDocumentApplicationsManuallyForDate()}
                                    buttonLabel="Confirmar"
                                    buttonLoading={feature.buttonsLoading}
                                    disabled={feature.buttonsLoading}
                                    minDate={accountingDocumentsStartingDate}
                                />
                                    <Box sx={style.synchronizationActionCell}>
                                        <LoadingButton sx={style.synchronizeButton}
                                                       onClick={() => feature.synchronizeAdjustments()}
                                                       loading={feature.buttonsLoading}
                                                       variant="contained"
                                        >
                                            {feature.buttonsLoading ? 'Sincronizando...' : 'Sincronización de ajustes'}
                                        </LoadingButton>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={style.pieceWithSeparator}>
                                <Typography sx={style.pieceTitle}>Balances</Typography>
                                <Box sx={style.stackedActions}>
                                    <LoadingButton sx={style.synchronizeButton}
                                                   onClick={() => feature.recalculateCurrentAccounts()}
                                                   loading={feature.buttonsLoading}
                                                   variant="contained"
                                    >
                                        {feature.buttonsLoading ? 'Recalculando...' : 'Recalcular balances de Cuentas Corrientes'}
                                    </LoadingButton>
                                </Box>
                            </Box>
                            <Box sx={style.pieceWithSeparator}>
                                <Typography sx={style.pieceTitle}>Notificaciones</Typography>
                                <Box sx={style.stackedActions}>
                                    <LoadingButton sx={style.synchronizeButton}
                                                   onClick={() => feature.emailMissingApplicationDocuments()}
                                                   loading={feature.buttonsLoading}
                                                   variant="contained"
                                    >
                                        {feature.buttonsLoading ? 'Enviando...' : 'Enviar mail de comprobantes faltantes'}
                                    </LoadingButton>
                                </Box>
                            </Box>
                        </FormColumn>
                    </FormSection>}
            </div>
        )
    }

    return <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => screenContent()}/>
}

const styles = (theme) => ({
    synchronizeButton: {
        backgroundColor: theme.brand.actionButton.bg,
        color: theme.brand.actionButton.text,
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    synchronizationsGrid: {
        display: 'grid',
        gridTemplateColumns: {xs: '1fr', md: 'repeat(2, minmax(0, 1fr))'},
        columnGap: theme.spacing(3),
        rowGap: theme.spacing(2),
    },
    synchronizationActionCell: {
        display: 'flex',
        alignItems: 'flex-end',
    },
    piece: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    pieceWithSeparator: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        paddingTop: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    pieceTitle: {
        fontSize: '0.85rem',
        fontWeight: 600,
        color: theme.palette.text.secondary,
    },
    stackedActions: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
    },
})

export default observer(SupportScreen)
